<template>
  <div class="app-container">
    <el-form :model="queryParams" ref="queryForm" label-width="80px">
      <el-row :gutter="10" class="mb8">
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="分类" prop="articleType">
            <el-select
              v-model="queryParams.articleType"
              placeholder="请选择"
              clearable
              style="width:100%"
            >
              <el-option
                v-for="dict in typeOptions"
                :key="dict.code"
                :label="dict.name"
                :value="dict.code"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="内容标题" prop="title">
            <el-input v-model="queryParams.title" placeholder="请输入" clearable />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="状态" prop="reviewStatus">
            <el-select
              v-model="queryParams.reviewStatus"
              placeholder="请选择"
              clearable
              style="width:100%"
            >
              <el-option
                v-for="dict in statusOptions"
                :key="dict.code"
                :label="dict.name"
                :value="dict.code"
              />
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
            <el-button icon="el-icon-refresh" @click="resetQuery">清空</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-table  v-loading="loading" :data="dataList">
      <el-table-column label="用户姓名" min-width="100" align="center" prop="nickName" />
      <el-table-column label="分类" min-width="80" align="center" prop="articleTypeStr" />
      <el-table-column label="内容标题" min-width="180" align="left" prop="title" />
      <el-table-column label="评论内容" align="left" min-width="200">
        <template slot-scope="scope">
          <el-popover
            placement="top-start"
            width="400"
            trigger="hover"
            :content="scope.row.commentContent">
            <span class="over-text" slot="reference">{{scope.row.commentContent}}</span>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column label="状态" min-width="80" align="center" prop="reviewStatusStr" />
      <el-table-column label="评论时间" min-width="150" align="center" prop="commentTime" />
      <el-table-column label="回复" align="left" min-width="200">
        <template slot-scope="scope">
          <el-popover
            placement="top-start"
            width="400"
            trigger="hover"
            :content="scope.row.replyContent">
            <span class="over-text" slot="reference">{{scope.row.replyContent}}</span>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="130" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="changeStatus(scope.row, 2)" v-if="scope.row.reviewStatus === 1">屏蔽</el-button>
          <el-button type="text" @click="changeStatus(scope.row, 1)" v-if="scope.row.reviewStatus === 0 || scope.row.reviewStatus === 2">展示</el-button>
          <el-button type="text" @click="handleRecomment(scope.row)" v-if="!scope.row.replyContent">回复</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="queryComment"
    />
    <ReplyCommentDialog ref="replyCommentDialogRef" @success="queryComment"></ReplyCommentDialog>
  </div>
</template>

<script>
import { queryComment, replyComment, commentExam } from "@/api/saas/package";
import ReplyCommentDialog from "./components/replyCommentDialog";
import { amountFormat } from "@/utils/index";

export default {
  name: "BusinessList",
  components: {
    ReplyCommentDialog
  },
  data() {
    return {
      recomment: "", // 回复内容
      visible: false, // 回复弹框
      data: { // 回复

      },
      typeOptions: [
        {
          code: 1,
          name: "文章"
        },
        {
          code: 2,
          name: "案例"
        },
        {
          code: 3,
          name: "产品"
        }
      ],
      statusOptions: [
        // {
        //   code: 0,
        //   name: "待审核"
        // },
        {
          code: 1,
          name: "正常展示"
        },
        {
          code: 2,
          name: "已屏蔽"
        }
      ],
      loading: false,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        reviewStatus: null,
        title: null,
        articleType: null
      },
      total: 30,
      dataList: []
    };
  },
  created() {
    this.queryComment();
  },
  methods: {
    changeStatus(row, reviewStatus) {
      commentExam({
        commentId: row.commentId,
        reviewStatus
      })
        .then(response => {
          this.msgSuccess('状态更改成功！')
          this.queryComment()
        })
        .catch(error => {
          this.loading = false;
        });
    },
    handleAdd() {
      this.$refs.addNoticeDialog.open();
    },
    handleRecomment(row) {
      this.visible = true;
      this.$refs.replyCommentDialogRef.open(row.commentId)
    },
    getList(e) {
      console.log("ee---", e);
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.queryComment();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.queryParams.userId = null;
      this.handleQuery();
    },
    queryComment() {
      this.loading = true;
      queryComment(this.queryParams)
        .then(response => {
          this.dataList = response.rows || [];
          this.loading = false;
          this.total = response.total
        })
        .catch(error => {
          this.loading = false;
        });
    },
    confirm() {

    }
  }
};
</script>
<style lang="scss" scoped>
.over-text {
  max-width: 200px;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
::v-deep.over-text-tips{
  width: 250px;
}
</style>
